const masonMistriService = {
  title: "Mason / Mistri",
  icon: "🧱",
  shortDescription:
    "Brick work, wall patching, small civil work, plastering, and masonry support.",
  longDescription:
    "Book skilled masonry support for small civil tasks, brick work, repair, patching, plaster, and site execution work. Final quote may vary by structure and material condition.",
  consultationNote:
    "Structural, large-area, or custom estimate jobs may require inspection first.",
  responsePromise:
    "Assignment depends on skill, job scale, and local worker availability.",
  warrantyPolicy:
    "Revisit support depends on work type, curing conditions, and completion context.",
  subServices: [
    {
      id: "mason-wall-patch",
      title: "Wall Patch Repair",
      icon: "🧱",
      group: "Repair",
      description:
        "Repair broken or damaged wall patch area with small masonry correction.",
      basePrice: 499,
      priceType: "starts_at",
      duration: "1-3 hrs",
      warranty: "3 days",
      unit: "job",
    },
    {
      id: "mason-small-brickwork",
      title: "Small Brickwork",
      icon: "🏗️",
      group: "Brick Work",
      description:
        "Small section brick laying or correction for non-major structural work.",
      basePrice: 799,
      priceType: "starts_at",
      duration: "2-4 hrs",
      warranty: "3 days",
      unit: "job",
    },
    {
      id: "mason-plaster-repair",
      title: "Plaster Repair",
      icon: "🪣",
      group: "Repair",
      description:
        "Fix small plaster damage, cracks, chipped sections, or surface patch areas.",
      basePrice: 599,
      priceType: "starts_at",
      duration: "1-3 hrs",
      warranty: "3 days",
      unit: "job",
    },
    {
      id: "mason-floor-levelling",
      title: "Minor Floor Levelling",
      icon: "📏",
      group: "Finishing Prep",
      description:
        "Small-area surface levelling before tile or finish work.",
      basePrice: 699,
      priceType: "starts_at",
      duration: "2-4 hrs",
      warranty: "3 days",
      unit: "job",
    },
    {
      id: "mason-inspection",
      title: "Civil Work Inspection",
      icon: "🔍",
      group: "Inspection",
      description:
        "Inspection for repair scope, wall breakage, plastering, tile base, or small civil planning.",
      basePrice: 349,
      priceType: "inspection",
      duration: "30-45 mins",
      warranty: "Inspection only",
      unit: "visit",
    },
  ],
};

export default masonMistriService;